import { ModalStore } from "assets/modals";
import { _Media_liquid, _Video_liquid } from "../@types/shopify";

export type MediaGalleryStore = {
  video_gallery_show: boolean;
  media: _Media_liquid[];
  videos: {
    video: Extract<_Media_liquid, { media_type: "external_video" | "video" }>;
    products: [string, number][];
    autoplay?: boolean;
    muted?: boolean;
    loop?: boolean;
    controls?: boolean;
  }[];
  index: number;
  showGallery: (input: { media: _Media_liquid[]; index: number }) => void;
  showVideoGallery: (element: HTMLElement, siblings: HTMLElement[]) => void;
};

export const initMediaGallery = () => {
  const modalStore = Alpine.store("modal") as ModalStore;

  window.Alpine.store("mediaGallery", {
    media: _products[Object.keys(_products)[0]]?.media ?? [],
    videos: [],
    index: 0,
    scrollIndex: 0,
    showGallery({ media = [], index = 0 }) {
      this.media = media;
      this.index = index;
      this.scrollIndex = index;
      modalStore.setId("media-gallery--vertical-gallery");
    },
    showVideoGallery(element, siblings) {
      const index = siblings.indexOf(element);
      this.videos = siblings.map((el) => {
        const video = utils.JSONParse(el.getAttribute("data-ugc-video"));
        const products = utils.JSONParse(el.getAttribute("data-ugc-products") ?? "[]");
        const autoplay = el.hasAttribute("data-autoplay");
        const muted = el.hasAttribute("data-muted");
        const loop = el.hasAttribute("data-loop");
        const controls = el.hasAttribute("data-controls");

        return {
          video:
            typeof video === "string"
              ? {
                  alt: el.textContent,
                  media_type: "external_video",
                  preview_image: null,
                  external_id: new URL(video)?.pathname.split(/[/?#]/gi)?.[1],
                  src: video,
                  host: video?.toLowerCase()?.includes("vimeo") ? "vimeo" : "youtube",
                }
              : video,
          products,
          autoplay,
          muted,
          loop,
          controls,
        };
      });
      this.index = index;
      this.scrollIndex = index;

      modalStore.setId("media-gallery--video-product-gallery");
    },
  });

  const mediaGalleryStore = window.Alpine.store("mediaGallery") as MediaGalleryStore;
  Alpine.effect(() => {
    if (!modalStore.id && mediaGalleryStore.media.length) {
      mediaGalleryStore.media = [];
    }
    if (!modalStore.id && mediaGalleryStore.videos.length) {
      mediaGalleryStore.videos = [];
    }
  });
  window.Alpine.magic("mediaGallery", () => mediaGalleryStore);
  window._stores["mediaGallery"] = mediaGalleryStore;
};

declare module "alpinejs" {
  interface Magics<T> {
    $mediaGallery: MediaGalleryStore;
  }
}
